var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { height: 100 + "vh" } },
    [
      _vm._m(0),
      _c("b-loading", {
        attrs: { "is-full-page": false },
        model: {
          value: _vm.isLoading,
          callback: function ($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading",
        },
      }),
      _c("section", { staticClass: "container max-width" }, [
        _vm.showError
          ? _c("div", [
              _c("p", { staticClass: "error-message" }, [
                _vm._v(
                  " 😥 This token is invalid, please contact customer service "
                ),
              ]),
            ])
          : _vm._e(),
        _vm.showDeclarationUI
          ? _c(
              "div",
              { staticClass: "d-flex-column d-flex-align-center" },
              [
                _c("div", { staticClass: "has-text-centered mb-5 welcome" }, [
                  _c("p", [_vm._v("Welcome")]),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.curEnduser.id) +
                        " - " +
                        _vm._s(_vm.curEnduser.name)
                    ),
                  ]),
                ]),
                _c(
                  "b-field",
                  [
                    _c(
                      "b-upload",
                      {
                        attrs: {
                          accept:
                            ".txt, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                          "drag-drop": "",
                        },
                        model: {
                          value: _vm.uploadedFile,
                          callback: function ($$v) {
                            _vm.uploadedFile = $$v
                          },
                          expression: "uploadedFile",
                        },
                      },
                      [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            { staticClass: "content has-text-centered" },
                            [
                              _c(
                                "p",
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "file", size: "is-large" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { staticClass: "file" },
                                [
                                  _c(
                                    "b-upload",
                                    {
                                      attrs: { expanded: "" },
                                      model: {
                                        value: _vm.uploadedFile,
                                        callback: function ($$v) {
                                          _vm.uploadedFile = $$v
                                        },
                                        expression: "uploadedFile",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        { staticClass: "button is-fullwidth" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.uploadedFile.name ||
                                                  "Upload"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("p", [_vm._v(" Drop your file here ")]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  [
                    _c(
                      "b-checkbox",
                      {
                        model: {
                          value: _vm.hasNothing,
                          callback: function ($$v) {
                            _vm.hasNothing = $$v
                          },
                          expression: "hasNothing",
                        },
                      },
                      [_vm._v(" I have nothing to declare ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    style: { marginBottom: 2 + "rem", marginTop: 1 + "rem" },
                    attrs: { type: "is-primary", disabled: _vm.isDisabled },
                    on: { click: _vm.upload },
                  },
                  [_vm._v(" Submit ")]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-info", "icon-left": "download" },
                    on: { click: _vm.getTemplate },
                  },
                  [_vm._v(" Download template ")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.showFeedback
          ? _c("div", { staticClass: "has-text-centered welcome" }, [
              _c("p", [_vm._v("Upload successfully")]),
              _c("p", [_vm._v("Thank you!")]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "has-text-centered" }, [
      _c("img", {
        staticStyle: { height: "20vh" },
        attrs: { src: require("@/assets/gps_logo.png"), alt: "GPS logo" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }